'use strict';

var React = require('react');
var Teaser = require('./Teaser');

class TeaserItem extends React.Component {
	render () {
		var item = this.props.model;
		if (!item) {
			return false;
		}

		return (
			<div key={item.id} className="svtse_grid__col-full-halves--small">
				<Teaser model={item} teaserArea="major" layout="type1" />
			</div>
		);
	}
}
Teaser.displayName = 'Teasers';


class MajorTeaserArea extends React.Component {

	render() {
		var model = this.props.model;

		if (!model || model.isEmpty()) {
			return false;
		}
		return (
			<div className="svtse_major-teaser-area">
				<div className="svtse_grid">
					{model.toJS().map(function (item, index) {
						return (
							<TeaserItem model={item} key={index} />
						);
					})}

				</div>
			</div>
		);
	}
}

MajorTeaserArea.displayName = 'MajorTeaserArea';
MajorTeaserArea.propTypes = {
	model: React.PropTypes.object.isRequired
};

module.exports = MajorTeaserArea;



/** WEBPACK FOOTER **
 ** ./app/components/Teaser/MajorTeaserArea.jsx
 **/